// Tipografia/box compartilhados dos badges de bottom-overlay do chart
// (countdown, price-change, pills Renko/P&F) — dedup auditoria 2026-07-17,
// item 5b. Constante JS (não classe CSS) de propósito: badges vivem em
// painéis que podem ser popped-out p/ janelas nativas — estilo inline não
// depende de propagação de stylesheet. Cor/interatividade ficam por badge.
export const CHART_OVERLAY_BADGE_STYLE = {
  padding: "6px 12px",
  borderRadius: "6px",
  fontSize: "13px",
  fontFamily: "monospace",
  fontWeight: "700",
  letterSpacing: "0.5px",
  userSelect: "none",
};
